import React from 'react'
import store from '../../store/Store'
import actions from '../../actions/Actions'

import mediaActions from './mediaActions'

import EditorMediaText from '../editorMediaText/EditorMediaText'
import EditorMediaImage from '../editorMediaImage/EditorMediaImage'
import EditorMediaVideo from '../editorMediaVideo/EditorMediaVideo'

import Icon from '@material-ui/core/Icon'
import IconButton from '@material-ui/core/IconButton'

import ImageIcon from '@material-ui/icons/Image'
import VideoLabelIcon from '@material-ui/icons/VideoLabel'
import TextFieldsIcon from '@material-ui/icons/TextFields'

import './editorMedia.scss'

type editorMediaState = {
  article: any;
  menu: any;
  navigation: any;
  row: any;
  column: any;
  rowSpan: any;
  colSpan: any;
}

type editorMediaProps = {
  article: any;
  menu: any;
  navigation: any;
  row: any;
  column: any;
  rowSpan: any;
  colSpan: any;
}

class EditorMedia extends React.Component<editorMediaProps, editorMediaState> {

  constructor(props) {
    super(props)

    this.state = {
      article: props.article,
      menu: props.menu,
      navigation: props.navigation,
      row: props.row,
      column: props.column,
      rowSpan: props.rowSpan,
      colSpan: props.colSpan
    }
  }

  componentDidMount() {
    store.subscribe(() => {
      this.setState({
        article: store.getState().article,
        menu: store.getState().menu,
        navigation: store.getState().navigation
      })
    })
  }

  componentWillUnmount() {
    store.subscribe(() => {
      this.setState({
        article: store.getState().article,
        navigation: store.getState().navigation
      })
    })
  }

  dragEnter = (event) => {
    // console.log('DRAG ENTER')

    // console.log(event)

    event.preventDefault()
    event.stopPropagation()
  }

  dragLeave = (event) => {
    // console.log('DRAG LEAVE')

    // console.log(event)

    event.preventDefault()
    event.stopPropagation()
  }

  dragOver = (event) => {
    // console.log('DRAG OVER')

    // console.log(event)

    event.preventDefault()
    event.stopPropagation()
  }

  drop = (event) => {
    // console.log('DROP')

    // console.log(event)
    // console.log(event.target)
    // console.log(event.target.id)
    // console.log(event.dataTransfer.files)

    let targetId = event.target.id

    event.preventDefault()
    event.stopPropagation()

    let reader = new FileReader()
    reader.readAsDataURL(event.dataTransfer.files[0])
    reader.onloadend = function() {
      let img = document.createElement('img')
      img.src = reader.result as string

      // console.log(img)

      img.style.width = '100%'
      img.style.height = '100%'
      document.getElementById(targetId).appendChild(img)
    }
  }

  render() {
    const {
      article,
      menu,
      navigation,
      row,
      column
    } = this.state

    let mediaId = mediaActions.getMediaId(article, row, column)
    let media = mediaActions.isMedia(article, row, column)
    let mediaType = mediaActions.getMediaType(article, row, column)

    // console.log('MediaId: ' + mediaId)
    // console.log('Media: ' + media)
    // console.log('MediaType: ' + mediaType)

    return (
      <div
        className='EditorMedia'
        style={{
          width: '100%',
          height: '100%'
        }}
        onClick={ () => { mediaActions.onClicked(this, article, mediaId, row, column) }}
        onMouseOver={ () => { mediaActions.onMouseOver(this, article, mediaId) }}
        onMouseOut={ () => { mediaActions.onMouseOut(this, article, mediaId) }}
        id={ mediaId }
      >

        {
          mediaType === 0 ? (
            <EditorMediaText
              article={ article }
              menu={ menu }
              navigation={ navigation }
              row={ row }
              column={ column }
              id={ mediaId }
            />
          ) : mediaType === 1 ? (
            <EditorMediaImage
              article={ article }
              navigation={ navigation }
              row={ row }
              column={ column }
              id={ mediaId }
            />
          ) : mediaType === 2 ? (
            <EditorMediaVideo
              article={ article }
              navigation={ navigation }
              row={ row }
              column={ column }
              id={ mediaId }
            />
          ) : mediaActions.mediaElement(article, navigation, article.info.currentPage, row, column)
        }
        
      </div>
    );
  }
}

export default EditorMedia;